let evaResultTable = [
  {
    label: "编号",
    prop: "userId",
  },
  {
    label: "姓名",
    prop: "username",
  },
  {
    label: "所属地区",
    prop: "regionName",
  },
  {
    label: "单位",
    prop: "bureauName",
  },
  {
    label: "部门",
    prop: "departmentName",
  },
  {
    label: "共性指标得分",
    prop: "commonScore",
  },
  {
    label: "个性指标得分",
    prop: "taskScore",
  },
  {
    label: "考勤得分",
    prop: "attendanceScore",
  },
  {
    label: "党委得分",
    prop: "specialScore",
  },
  {
    label: "综合得分",
    prop: "totalScore",
  },
  {
    label: "考核等次",
    prop: "level",
  },
  {
    label: "排名",
    prop: "rank",
  },
]

// 全年
let evaResultTable2 = [
  {
    label: "编号",
    prop: "userId",
  },
  {
    label: "姓名",
    prop: "username",
  },
  {
    label: "所属地区",
    prop: "regionName",
  },
  {
    label: "单位",
    prop: "bureauName",
  },
  {
    label: "部门",
    prop: "departmentName",
  },
  {
    label: "第一季度",
    prop: "season1",
  },
  {
    label: "第二季度",
    prop: "season2",
  },
  {
    label: "第三季度",
    prop: "season3",
  },
  {
    label: "第四季度",
    prop: "season4",
  },
  {
    label: "考核等次",
    prop: "level",
  },
]

let evaResultList = []

export {
  evaResultTable,
  evaResultTable2,
  evaResultList
}